// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input {
  padding: 1rem;
  background-color: #F1F5F9;
  border-radius: 1rem;
  border: 1px solid rgba(21, 21, 21, 0.2509803922);
  outline: none;
  font-size: 1rem;
  width: 100%;
  transition-duration: 250ms;
}
.input:focus {
  border-color: #A1C7FF;
}
.input:disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0;
}
.input--required {
  border: 1px solid #EF3124;
}`, "",{"version":3,"sources":["webpack://./src/components/FormikField/FormikField.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,yBCmCiB;EDlCjB,mBAAA;EACA,gDAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;AADF;AAGE;EACE,qBCFc;ADClB;AAIE;EACE,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,UAAA;AAFJ;AASE;EACE,yBAAA;AAPJ","sourcesContent":["@import 'src/styles/variables';\n\n.input {\n  padding: 1rem;\n  background-color: $input-background;\n  border-radius: 1rem;\n  border: 1px solid $black-25;\n  outline: none;\n  font-size: 1rem;\n  width: 100%;\n  transition-duration: 250ms;\n\n  &:focus {\n    border-color: $main-light-blue;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    user-select: none;\n    opacity: 0;\n  }\n\n  &__filled {\n\n  }\n\n  &--required {\n    border: 1px solid $alfa-bank;\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
